import { siteApiSlice } from "../../../../../app/siteApiSlice";

export interface WriterEssayDraftHistoryViewModel {
	writerId: number;
	writerFormalFullName: string;
	essays: EssayHistoryViewModel[];
}

export interface EssayHistoryViewModel {
	essayId: number;
	promptId: number;
	promptName: string;
	isConstructedResponse: boolean;
	drafts: DraftHistoryViewModel[];
}

export interface DraftHistoryViewModel {
	draftId: number;
	draftScore: number;
	draftCreateDate: string;
}

export const essayDraftHistoryReportApiSlice = siteApiSlice.injectEndpoints({
	endpoints: (build) => ({
		essayDraftHistoryReport: build.query<
			WriterEssayDraftHistoryViewModel[],
			{ courseId?: number; writerId?: number | null }
		>({
			query: (arg) => {
				const { courseId, writerId } = arg;
				return {
					url: `/essay-draft-history-report`,
					params: { courseId, writerId },
				};
			},
		}),
	}),
});

export const { useEssayDraftHistoryReportQuery } = essayDraftHistoryReportApiSlice;
